import React from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import EInvoiceList from "./einvoice/EInvoiceList";

const EInvoicePage = () => (
  <>
    {/* <Row>
      <Colxx xxs="12">
        <div className="mb-2">
          <h1>
            <IntlMessages id="menu.einvoice" />
          </h1>
          <Separator className="mb-5" />
        </div>
      </Colxx>
    </Row> */}
    <EInvoiceList />
  </>
);

export default EInvoicePage;
